import Vue from 'vue'
import DialogInstall from './install'

Vue.use(DialogInstall)
